import {
  Menu as HeadlessMenu,
  MenuButton as HeadlessMenuButton,
  MenuItems as HeadlessMenuItems,
  MenuItem as HeadlessMenuItem,
} from '@headlessui/react'
import { ReactNode } from 'react'
import { cn } from '../utilities.ts'

type MenuProps = {
  children: ReactNode
  className?: string
}

export function Menu({ children, className }: MenuProps) {
  return (
    <HeadlessMenu as="div" className={cn('relative', className)}>
      {children}
    </HeadlessMenu>
  )
}

type MenuButtonProps = {
  children: ReactNode
  className?: string
}

export function MenuButton({ children, className }: MenuButtonProps) {
  return (
    <HeadlessMenuButton
      className={cn(
        'menu-toggle btn btn-sm btn-icon btn-light btn-clear',
        className
      )}
    >
      {children}
    </HeadlessMenuButton>
  )
}

type MenuItemsProps = {
  children: ReactNode
  className?: string
}

export function MenuItems({ children, className }: MenuItemsProps) {
  return (
    <HeadlessMenuItems
      className={cn(
        'absolute right-0 z-50 p-2 text-xs font-medium text-gray-900 mt-2 min-w-min w-32 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in',
        className
      )}
    >
      {children}
    </HeadlessMenuItems>
  )
}

type MenuItemProps = {
  children: ReactNode
  onClick?: () => void
  className?: string
}

export function MenuItem({ children, onClick, className }: MenuItemProps) {
  return (
    <HeadlessMenuItem
      as="div"
      className={cn(
        'p-2 data-[focus]:bg-primary-100 data-[focus]:rounded-md data-[focus]:text-gray-900 cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      {children}
    </HeadlessMenuItem>
  )
}
